/* ══════════════════════════════════════════════════════════════════════════
 * CLS-DK school shop — what the customer-facing shop looks like.
 * Shared by SchoolShop and the CreateShop review preview so the preview can
 * never drift from the real shop (banner photos, FOMO copy, card labels).
 * ══════════════════════════════════════════════════════════════════════════ */
import vogntrojerDesktop from '../../../../assets/cls-dk/school-shop/Vogntrojer-Desktop.jpg';
import vogntrojerMobile from '../../../../assets/cls-dk/school-shop/Vogntrojer-Mobile.jpg';

// SecondaryBanner photo per shop type (menu item) — the STATIC fallback behind
// the brand's uploaded header images (variations payload `menuItemImages`).
// Unlisted keys (menu_1 Studieturstrøjer) fall back to the DS default photo.
export const BANNER_IMAGES = {
  menu_2: { backgroundImage: vogntrojerDesktop, backgroundImageMobile: vogntrojerMobile },
};

// FomoBlock copy: shop close date, or the class/shop payment deadline when set.
// Live countdown, or the fixed date ("date" display mode). Units: DS default d/t/m.
export const FOMO_COUNTDOWN_TEMPLATE = 'Skynd dig! Webshoppen lukker om {time}';
export const FOMO_DATE_TEMPLATE = 'Webshoppen lukker {time}';
export const FOMO_PAYMENT_COUNTDOWN_TEMPLATE = 'Skynd dig! Betalingsfristen udløber om {time}';
export const FOMO_PAYMENT_DATE_TEMPLATE = 'Betalingsfristen udløber {time}';

// ProductCard copy.
export const PACKAGE_DESCRIPTION = 'Pakkeløsning';
export const MORE_LABEL = 'flere';
